import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_PLATFORM_FRAUD_EMAIL_DOMAINS = createFcmDetails('platform_fraud_email_domains', {
	owner: 'Site Platform',
	context: 'monorail',
	description:
		'Used in the signature verification process to block automated verification of signatures from known bad email domains. Comma-separated list of email domains.',
	import: false,
});
